(function () {
    'use strict';

    function internalContentConfiguration($http, $compile) {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/internalContentConfiguration.html',
            //scope: {
            //    Phase: '=phase',
            //    itemOperationsTarget: '='
            //},
            link: function (scope, element, attrs) {
                //$compile(element)(scope);
            }
        };
    }

    internalContentConfiguration.$inject = ['$http', '$compile'];

    angular.module('ecap.siteConfiguration').directive('internalContentConfiguration', internalContentConfiguration);
})();